import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { onMounted, ref } from 'vue';
import * as GameTypes from 'types/game.types';
import { useMotion } from '@vueuse/motion';
import { hapticsImpactLight } from 'src/util/device-util';
import ColorPhasingElement from './color-phasing-element.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'phasing-button',
  props: {
    targetColor: null,
    steps: null,
    shape: null,
    delay: null
  },
  emits: ['enter', 'select'],
  setup(__props: any, { expose, emit }) {

const props = __props as {
    /**
     * The target color, which is only used to ensure that any step w/ the color set to 'random'
     * will be a color that is sufficiently different from the target color.
     */
    targetColor: chroma.Color,
    /**
     * The color phase steps
     */
    steps: GameTypes.PhaseStep[],
    shape?: 'circle' | 'square'
    delay?: number
}





const handlePointerDown = () => {
    hapticsImpactLight();
    /**
     * The stop method returns a hex color value.
     */
    emit('select', phaseRef.value.stop());
}

const phaseRef = ref();
const motion = useMotion(phaseRef, {
    initial: {
        //opacity: 0,
        //y: 300,
        scale: 0
    },
    enter: {
        //y: 0,
        //opacity: 1,
        scale: 1,
        transition: {
            delay: props.delay ?? 0,
            duration: 500,
            ease: 'easeOut'
        }
    },
    // leave: {
    //     opacity: 0,
    //     y: -300,
    //     transition: {
    //         duration: 225,
    //         ease: 'easeIn'
    //     },
    // }
})

const btnClass = props.shape === 'circle' ? 'k-phase-btn k-single-color-btn--circle' : 'k-phase-btn';
// const btnClass = sample([
//     'k-phase-btn',
//     'k-phase-btn k-single-color-btn--circle'
// ])!;

const toExpose = {
    stop: () => phaseRef.value.stop(),
    leave: (delay: number = 0) => {
        phaseRef.value.stop()
        return motion.apply({
            //opacity: 0,
            //y: 300,
            scale: 0,
            transition: {
                delay: delay,
                duration: 225,
                ease: 'easeIn'
            }
        })
    }
}

onMounted(() => {
    emit('enter', toExpose);
});

expose(toExpose)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ColorPhasingElement, _mergeProps({
    ref_key: "phaseRef",
    ref: phaseRef
  }, _ctx.$attrs, {
    is: "button",
    onPointerdown: handlePointerDown,
    targetColor: props.targetColor,
    steps: props.steps,
    class: _unref(btnClass)
  }), null, 16, ["targetColor", "steps", "class"]))
}
}

})